import { render, staticRenderFns } from "./XPickButton.vue?vue&type=template&id=77bdf90a&scoped=true&"
import script from "./XPickButton.vue?vue&type=script&lang=js&"
export * from "./XPickButton.vue?vue&type=script&lang=js&"
import style0 from "./XPickButton.vue?vue&type=style&index=0&id=77bdf90a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bdf90a",
  null
  
)

export default component.exports